
import { styled } from '@mui/material/styles';
import { Box, Typography, Container, Paper } from '@mui/material';

export const PageContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const HeaderSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: '#1a1a1a',
}));

export const PageSubtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'left', // Ensure left alignment for content
  border: '1px solid #e0e0e0',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: '#fff',
}));

export const TabPanelBox = styled(Box)(({ theme }) => ({
  // padding: theme.spacing(3, 0),
}));
